import "./App.css";
import Header from "./components/Header";
import Introduction from "./components/Introduction";
import Features from "./components/Features";
import IdeaSlider from "./components/IdeaSlider";
import VideoSection from "./components/VideoSection";
import KeyFeatures from "./components/KeyFeatures";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Introduction />
      <VideoSection />
      <IdeaSlider />
      <Features />
      <KeyFeatures />
      <Footer />
    </div>
  );
}

export default App;
